import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SearchProductModeSwitcherService } from '@sdvor/layout/feature';
import { SdvorSearchBoxContainerComponent } from '../searchbox-container';

@Component({
  selector: 'sd-search-product',
  imports: [SdvorSearchBoxContainerComponent],
  templateUrl: './search-product.component.html',
  styleUrls: ['./search-product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchProductComponent implements OnInit, OnDestroy {
  @Input() isHomePage = false;

  constructor(protected searchProductModeSwitcherService: SearchProductModeSwitcherService) {}

  ngOnInit(): void {
    this.searchProductModeSwitcherService.changeMode(true);
  }

  ngOnDestroy(): void {
    this.searchProductModeSwitcherService.changeMode(false);
  }
}
